import React, { ReactNode, useState } from 'react';
import { Button, ButtonVariant } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { t } from '@stores/localization';

import { ParkingSpaceWatchDialog } from '../pages/ParkingSpaceListingPage/components/ParkingSpaceWatchDialog';

interface Props {
  children?: ReactNode;
  variant?: ButtonVariant;
  className?: string;
}

/** Button that opens the dialog for ordering a parking space watch for the selected apartment's parking areas */
export const ParkingSpaceWatchButton = observer(
  ({ children, variant, className }: Props) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    return (
      <>
        <Button
          variant={variant}
          className={className}
          onClick={() => setIsDialogOpen(true)}
        >
          {children ?? t('parking.order_notifications')}
        </Button>

        <ParkingSpaceWatchDialog
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
        />
      </>
    );
  }
);
